import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath } from "../../config/Constant";
import { getNotificationFailure, getNotificationRequest, getNotificationSuccess } from "../Reducers/notificationReducer";

export const guestJourneyNotification = () => {

  return async dispatch => {

    dispatch(getNotificationRequest());

    try {

      const sessionToken = await AsyncStorage.getItem('sessionToken');
      const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

      let room = await AsyncStorage.getItem('room');

      // let room = await AsyncStorage.getItem("room");
      room = room && room !== "null" ? room : "notLogin";

      const response = await clientConfigPath.put(
        "/textMessage/fetch" + `?dId=${DeviceIdentifier}&rn=${room}`,
        {
          "payload": {},
          "header": {
            "sessionToken": sessionToken,
            "requester": "webApp"
          }
        }
      );


      if (response && response.data && response.data.payload && response.data.payload.messages) {
        // Dispatch the action to update the Redux store with the fetched messages
        dispatch(getNotificationSuccess(response.data.payload.messages));
      
      } else {
        // Dispatch an action with an empty array if no messages are found
        dispatch(getNotificationSuccess({ notifications: [] }));
      
      }
    } catch (error) {

      dispatch(getNotificationFailure());
      if (error.response && error.response.status === 401) {
        // Handle unauthorized error, possibly wipe guest data
        // wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" });
        console.log("Unauthorized access, wiping guest data...");
      }
      console.log(`error in api call to path= "/textMessage/fetch"`, error);
    }
  }
}



